// ============================================================
// API URL resolver for the marketing site.
//
// During the custom-domain migration the marketing site can be
// served on either the legacy pages.dev host OR the new
// `ai.wavefrontstudiollc.com` host. Pick the matching API host at
// runtime so the same SPA bundle works on both.
// ============================================================

export function resolveApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'wavefrontstudiollc.com' || host.endsWith('.wavefrontstudiollc.com')) {
      return 'https://api.wavefrontstudiollc.com';
    }
  }
  return 'https://omnichannel-api.wavefrontstudio.workers.dev';
}

export const API_BASE_URL = resolveApiBaseUrl();
